import { useMemo, useState } from "react";
import { useTable } from "react-table";
import {
  defaultDateDisplay,
  extractReadableDateOnly,
  formatCurrency,
} from "../../../helpers";
import { useSearchParams } from "react-router-dom";
import primaryComponents from "../../primaryComponents";

const useVatOutflowsTable = ({ vatOutflowData, selectedTab }) => {
  const [search] = useSearchParams();
  const [selectedOrder, setSelectedOrder] = useState(
    search.get("orderId") || null,
  );
  const [selectedReturnOrder, setSelectedReturnOrder] = useState(
    search.get("returnOrderId") || null,
  );

  const columns = useMemo(
    () => [
      {
        Header: "VAT Entry Date",
        accessor: "vat_period",
        Cell: ({ cell: { value } }) => (
          <span>{extractReadableDateOnly(value)}</span>
        ),
      },
      {
        Header: "VAT Amount Paid",
        accessor: "amount",
        Cell: ({ cell: { value }, row }) => (
          <span
            style={{
              color: value < 0 ? "#E02020" : "#27AE60",
              fontWeight: 500,
            }}
          >
            {formatCurrency({
              value: value,
              currencyCode: row?.original?.store?.currency_code,
            })}
          </span>
        ),
      },
      {
        Header: "Total Amount Paid",
        accessor: "total_amount",
        Cell: ({ cell: { value }, row }) => (
          <span>
            {formatCurrency({
              value: value,
              currencyCode: row?.original?.store?.currency_code,
            })}
          </span>
        ),
      },
      {
        Header: "Net Amount",
        accessor: "net_amount",
        Cell: ({ cell: { value }, row }) => (
          <span>
            {formatCurrency({
              value: value,
              currencyCode: row?.original?.store?.currency_code,
            })}
          </span>
        ),
      },
      {
        Header: "Store",
        accessor: "store",
        Cell: ({ cell: { value } }) => <span>{value?.name || "N/A"}</span>,
      },
      {
        Header: "Source",
        accessor: "source",
        Cell: ({ cell: { value } }) => (
          <span>
            {value?.charAt(0)?.toUpperCase() + value?.slice(1)?.toLowerCase()}
          </span>
        ),
      },
      {
        Header: "Transaction Type",
        accessor: "source_description",
        Cell: ({ cell: { value } }) => <span>{value}</span>,
      },
      {
        Header: "VAT Charged?",
        accessor: "is_charged",
        Cell: ({ cell: { value } }) => <span>{value ? "Yes" : "No"}</span>,
      },
      {
        Header: "Created On",
        accessor: "created_at",
        Cell: ({ cell: { value } }) => <span>{defaultDateDisplay(value)}</span>,
      },
      {
        Header: "Description",
        accessor: "description",
        Cell: ({ cell: { value }, row }) => <span>{value}</span>,
      },
      {
        Header: "VAT Recoverable?",
        accessor: "is_recoverable",
        Cell: ({ cell: { value } }) => <span>{value ? "Yes" : "No"}</span>,
      },
      {
        Header: "Action",
        accessor: "reference",
        Cell: ({ cell: { value }, row }) => (
          <span>
            <span>
              {row?.original?.entity_type === "ORDER" && (
                <primaryComponents.Button
                  className="btn btn--primary smallBtn"
                  onClick={() => {
                    setSelectedOrder(value);
                  }}
                >
                  View
                </primaryComponents.Button>
              )}
              {row?.original?.entity_type === "RETURNS" && (
                <primaryComponents.Button
                  className="btn btn--primary smallBtn"
                  onClick={() => {
                    setSelectedReturnOrder(value);
                  }}
                >
                  View
                </primaryComponents.Button>
              )}
            </span>
          </span>
        ),
      },
    ],
    [selectedTab],
  );

  const instance = useTable({
    columns: columns,
    data: vatOutflowData,
  });

  return {
    instance,
    selectedOrder,
    selectedReturnOrder,
    setSelectedOrder,
    setSelectedReturnOrder,
  };
};

export default useVatOutflowsTable;
